<template>
  <div>
    <globalhead></globalhead>
    <div class="contactpage">
      <div class="main padding-top-10">
        <div class="main_zh_shop">
          <div class="help_left fl" id="helpMenu" module="menu-help">
            <div class="help_left_top fl">
              <dl>
                <dt class="J_helpMenuTitle" @click="listToggle(0)">购物指南</dt>
                <dd>
                  ·
                  <a href="/help?path=shopstep_0_0">购物流程</a>
                </dd>
                <dd>
                  ·
                  <a href="/help?path=pays_0_1">支付方式</a>
                </dd>
                <dd>
                  ·
                  <a href="/help?path=cproblem_0_2">常见问题</a>
                </dd>
              </dl>
            </div>
            <div class="help_left_top fl">
              <dl>
                <dt class="J_helpMenuTitle" @click="listToggle(1)">配送政策</dt>
                <dd>
                  ·
                  <a href="/help?path=explans_1_0">配送说明</a>
                </dd>
                <dd>
                  ·
                  <a href="/help?path=notice_1_1">配送须知</a>
                </dd>
                <dd>
                  ·
                  <a href="/help?path=sign_1_2">验货签收</a>
                </dd>
                <dd>
                  ·
                  <a href="/help?path=answer_1_3">配送答疑</a>
                </dd>
              </dl>
            </div>
            <div class="help_left_top fl">
              <dl>
                <dt class="J_helpMenuTitle" @click="listToggle(2)">售后服务</dt>
                <dd>
                  ·
                  <a href="/help?path=range_2_0">退换货范围</a>
                </dd>
                <dd>
                  ·
                  <a href="/help?path=rule_2_1">退换货细则</a>
                </dd>
                <dd>
                  ·
                  <a href="/help?path=refundment_2_2">退款说明</a>
                </dd>
                <dd>
                  ·
                  <a href="/help?path=way_2_3">售后联系方式</a>
                </dd>
              </dl>
            </div>
            <!-- <div class="help_left_top fl">
            <dl>
              <dt class="J_helpMenuTitle" @click="listToggle(3)">关于我们</dt>
              <dd>·<a href="#">公司介绍</a></dd>
              <dd>·<a href="#">联系方式</a></dd>
              <dd>·<a href="#">加入我们 </a></dd>
            </dl>
            </div>-->
          </div>

          <!-- include: common/helpMenu -->
          <component :is="helpPath"></component>
        </div>
      </div>
    </div>
    <globalfoot></globalfoot>
  </div>
</template>

<script>
import globalhead from "@/components/Global-Head";
import globalfoot from "@/components/Global-Foot";
import sign from "@/components/Help/sign.vue";
import explans from "@/components/Help/explans.vue";
import notice from "@/components/Help/notice.vue";
import answer from "@/components/Help/answer.vue";
import shopstep from "@/components/Help/shopstep.vue";
import pays from "@/components/Help/pays.vue";
import cproblem from "@/components/Help/cproblem.vue";

import range from "@/components/Help/range.vue";
import rule from "@/components/Help/rule.vue";
import refundment from "@/components/Help/refundment.vue";
import way from "@/components/Help/way.vue";

import $ from "jquery";
export default {
  components: {
    globalhead,
    globalfoot,
    // help
    sign,
    explans,
    notice,
    answer,
    shopstep,
    pays,
    cproblem,
    range,
    rule,
    refundment,
    way
  },
  data() {
    return {
      path: "",
      helpPath: ""
    };
  },
  mounted() {
    $(".J_helpMenuTitle").each(function() {
      $(this)
        .siblings("dd")
        .hide();
    });
    let keys = this.getUrlKey("path");
    if (keys) {
      this.helpPath = keys.split("_")[0];
      this.caseMenu(keys);
    }
  },
  methods: {
    caseMenu(keys) {
      let i1 = keys.split("_")[1];
      let i2 = keys.split("_")[2];
      $(".J_helpMenuTitle")
        .eq(i1)
        .siblings("dd")
        .show()
        .eq(i2)
        .addClass("on");
    },
    listToggle(index) {
      $(".J_helpMenuTitle")
        .eq(index)
        .siblings("dd")
        .toggle();
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    }
  }
};
</script>

<style>
@import url("../assets/css/help.css");
.J_helpMenuTitle {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.contactpage {
  background: #fff;
  margin: 0 auto;
  width: 1190px;
}
</style>
